module.exports = __webpack_public_path__ + "static/media/8OLA6.12364180.jpg";